import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { feedbackMixin } from '@/mixins/appMixin'
import moneyFilter from '@/filters/moneyFilter'
import '@/components/base/_globals'
import '@/assets/css/colors.css'
import '@/assets/css/tailwind.css'
import ElementUI from 'element-ui'
import '../theme/index.css'
import { Outside } from '@/components/directives/Outside.js'

Vue.use(ElementUI)
Vue.mixin(feedbackMixin)
Vue.directive('outside', Outside)
Vue.filter('money', moneyFilter)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
